import {initWebComponent} from "@/helpers/web-component-helper";
import {OlZoomInComponent} from "@/components/ol/buttons/ol-zoom-in-component";
import {OlZoomOutComponent} from "@/components/ol/buttons/ol-zoom-out-component";
import {OlDragZoomComponent} from "@/components/ol/buttons/ol-drag-zoom-component";
import {OlTrackLocationComponent} from "@/components/ol/buttons/ol-track-location-component";
import {CesiumEnableComponent} from "@/components/cesium/buttons/cesium-enable-component";
import {FooterButtonComponent} from "@/components/layout/buttons/footer-button-component";
import {OlMapSwitcherComponent} from "@/components/ol/buttons/ol-map-switcher-component";
import {OlSliderComponent} from "@/components/ol/buttons/ol-slider-component.js";
import {OlOverViewMapComponent} from "@/components/ol/buttons/ol-over-view-map-component.js";
import {FooterButtonRightComponent} from "@/components/layout/buttons/footer-button-right-component.js";
import {isMobile} from "@/helpers/mobile-helper.js";

const template = document.createElement('template');
let innerHTML = `<nav class="layout-footer footer bg-transparent pt-3" style="z-index: 0">
  <ol-map-switcher class="divBackgroundLayers d-none"></ol-map-switcher>
  <ol-zoom-in class="divZoomIn d-none"></ol-zoom-in>
  <ol-zoom-out class="divZoomOut d-none"></ol-zoom-out>
  <ol-drag-zoom class="divZoomRectangle d-none"></ol-drag-zoom>
  <ol-track-location class="divCurrentLocation d-none"></ol-track-location>
  <ol-slider class="divCompareMaps d-none"></ol-slider>
  <cesium-enable class="divEnable3D d-none"></cesium-enable>
</nav>`;

if (!isMobile()) {
    innerHTML +=
        `<nav class="layout-footer-right footer bg-transparent pt-3" style="z-index: 0">
            <ol-over-view-map class="divOverViewMap d-none"></ol-over-view-map>
        </nav>`;
}


template.innerHTML = innerHTML;

export class LayoutFooterComponent extends HTMLElement{
    constructor(){
        super();
        initWebComponent(this, template)
    }
}

window.customElements.define("ol-map-switcher", OlMapSwitcherComponent);
window.customElements.define("ol-zoom-in", OlZoomInComponent);
window.customElements.define("ol-zoom-out", OlZoomOutComponent);
window.customElements.define("ol-drag-zoom", OlDragZoomComponent);
window.customElements.define("ol-track-location", OlTrackLocationComponent);
window.customElements.define("ol-slider", OlSliderComponent);
window.customElements.define("ol-over-view-map", OlOverViewMapComponent);

window.customElements.define("cesium-enable", CesiumEnableComponent);

window.customElements.define("footer-button", FooterButtonComponent);
window.customElements.define("footer-button-right", FooterButtonRightComponent);